import { Button } from "@/components/ui/button";
import { MoreHorizontal, RefreshCw, RotateCcw } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ProductActionsProps {
  item: any;
  onSaleClick: (item: any) => void;
  onRestock: (item: any) => void;
  onLoss: (item: any) => void;
  onDelete: (item: any) => void;
  onReturn: (item: any) => void;
}

export const ProductActions = ({
  item,
  onSaleClick,
  onRestock,
  onLoss,
  onDelete,
  onReturn,
}: ProductActionsProps) => {
  return (
    <div className="flex items-center gap-2">
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={() => onRestock(item)}
        className="flex items-center gap-1 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
      >
        <RefreshCw className="h-4 w-4" />
        Réapprovisionner
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onReturn(item)}
        className="flex items-center gap-1 text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50"
      >
        <RotateCcw className="h-4 w-4" />
        Retour
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Ouvrir le menu</span>
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => onSaleClick(item)}>
            Vendre
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onLoss(item)}>
            Enregistrer une perte
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onDelete(item)}>
            Supprimer
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};